/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrUpdateIdentityProviderDto
 */
export interface CreateOrUpdateIdentityProviderDto {
    /**
     * サードパーティ種別
     * @type {string}
     * @memberof CreateOrUpdateIdentityProviderDto
     */
    thirdPartyType: CreateOrUpdateIdentityProviderDtoThirdPartyTypeEnum;
    /**
     * サードパーティId
     * @type {string}
     * @memberof CreateOrUpdateIdentityProviderDto
     */
    thirdPartyId?: string;
    /**
     * 認証プロバイダー名
     * @type {string}
     * @memberof CreateOrUpdateIdentityProviderDto
     */
    name: string;
    /**
     * クライアントID
     * @type {string}
     * @memberof CreateOrUpdateIdentityProviderDto
     */
    clientId: string;
    /**
     * クライアントシークレット
     * @type {string}
     * @memberof CreateOrUpdateIdentityProviderDto
     */
    clientSecret: string;
    /**
     * OIDCディスカバリーエンドポイント
     * @type {string}
     * @memberof CreateOrUpdateIdentityProviderDto
     */
    oidcDiscoveryEndpoint?: string;
    /**
     * OAuth Scope
     * @type {Array<string>}
     * @memberof CreateOrUpdateIdentityProviderDto
     */
    scope?: Array<string>;
}


/**
 * @export
 */
export const CreateOrUpdateIdentityProviderDtoThirdPartyTypeEnum = {
    Google: 'google',
    Github: 'github',
    Gitlab: 'gitlab',
    Slack: 'slack',
    Custom: 'custom'
} as const;
export type CreateOrUpdateIdentityProviderDtoThirdPartyTypeEnum = typeof CreateOrUpdateIdentityProviderDtoThirdPartyTypeEnum[keyof typeof CreateOrUpdateIdentityProviderDtoThirdPartyTypeEnum];


/**
 * Check if a given object implements the CreateOrUpdateIdentityProviderDto interface.
 */
export function instanceOfCreateOrUpdateIdentityProviderDto(value: object): value is CreateOrUpdateIdentityProviderDto {
    if (!('thirdPartyType' in value) || value['thirdPartyType'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientSecret' in value) || value['clientSecret'] === undefined) return false;
    return true;
}

export function CreateOrUpdateIdentityProviderDtoFromJSON(json: any): CreateOrUpdateIdentityProviderDto {
    return CreateOrUpdateIdentityProviderDtoFromJSONTyped(json, false);
}

export function CreateOrUpdateIdentityProviderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateIdentityProviderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'thirdPartyType': json['thirdPartyType'],
        'thirdPartyId': json['thirdPartyId'] == null ? undefined : json['thirdPartyId'],
        'name': json['name'],
        'clientId': json['clientId'],
        'clientSecret': json['clientSecret'],
        'oidcDiscoveryEndpoint': json['oidcDiscoveryEndpoint'] == null ? undefined : json['oidcDiscoveryEndpoint'],
        'scope': json['scope'] == null ? undefined : json['scope'],
    };
}

export function CreateOrUpdateIdentityProviderDtoToJSON(json: any): CreateOrUpdateIdentityProviderDto {
    return CreateOrUpdateIdentityProviderDtoToJSONTyped(json, false);
}

export function CreateOrUpdateIdentityProviderDtoToJSONTyped(value?: CreateOrUpdateIdentityProviderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'thirdPartyType': value['thirdPartyType'],
        'thirdPartyId': value['thirdPartyId'],
        'name': value['name'],
        'clientId': value['clientId'],
        'clientSecret': value['clientSecret'],
        'oidcDiscoveryEndpoint': value['oidcDiscoveryEndpoint'],
        'scope': value['scope'],
    };
}

